import moment from 'moment'
import { api } from 'api'
import { POST } from '@global/api/endpoints'
import {
  DatasetSubmissionOutboundIntegration,
  DatasetSubmissionIntegrationAssignment,
} from './types'

export const FILE_BASE_INTEGRATIONS = [
  'azure-blob-push',
  'adobe',
  'google-cloud',
  'email-output',
  'sftp-push',
  's3-push',
] // slugs

export const outboundIntegrationAssignmentHasErrors = (
  assignment: DatasetSubmissionIntegrationAssignment,
) => assignment.orchestrationHistory[0]?.status === 'error'

export async function resyncAllFailedIntegrationAssignments(
  integrationAssignments: DatasetSubmissionIntegrationAssignment[],
  datasetSubmissionId: number,
) {
  const url = POST.outboundOrchestrationSend()

  const promises = integrationAssignments
    .map(({ orchestrationHistory }) =>
      orchestrationHistory[0]?.batches
        .filter(({ status }) => status === 'error')
        .map(({ batchRevisionFile }) =>
          api.post(url, { datasetSubmissionId, revisionFileName: batchRevisionFile }),
        ),
    )
    .flat(1)

  return Promise.all(promises)
}

export async function resyncAllFailedIntegrations(
  integrations: DatasetSubmissionOutboundIntegration[],
  datasetSubmissionId: number,
) {
  const promises = integrations
    .map(({ integrationAssignments }) =>
      resyncAllFailedIntegrationAssignments(integrationAssignments, datasetSubmissionId),
    )
    .flat(1)

  return Promise.all(promises)
}

export const outboundIntegrationHasHistory = (
  outboundIntegration?: DatasetSubmissionOutboundIntegration | null,
) =>
  outboundIntegration?.integrationAssignments.some(a => a.orchestrationHistory.length > 0) || false

export function formatDate(date: string | null) {
  if (!date) return ''

  return moment(date).format('lll')
}
